import { Box, Modal } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const SetupPrepayment = ({ record, setRecord }) => {
  console.log("record", record);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");

  const [startDate, setStartDate] = useState("");
  const [monthDuration, setMonthDuration] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    !startDate &&
      record?.createdDate &&
      setStartDate(new Date(record?.createdDate)?.toISOString().split("T")[0]);
  }, [record]);

  useEffect(() => {
    function getMonthDuration(startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      const yearsDiff = end.getFullYear() - start.getFullYear();
      const monthsDiff = end.getMonth() - start.getMonth();

      return yearsDiff * 12 + monthsDiff;
    }
    setMonthDuration(getMonthDuration(startDate, endDate));
  }, [startDate, endDate]);
  useEffect(() => {
    setAmount(record?.principal / (monthDuration || 1));
  }, [monthDuration, record]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      accountLedgerID: record?.accountLedgerId,
      startDate: e.target.elements["startDate"].value,
      endDate: e.target.elements["endDate"].value,
      monthDuration: monthDuration,
      amount: amount,
    };
    const token = JSON.parse(localStorage.getItem("user")).userToken;
    axios
      .post(
        process.env.REACT_APP_BACKEND_FINANCE_SERVICE_URL +
          "/AccountLedger/Prepayment",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((data) => {
        if (data.data.successful) {
          toast.success(data?.data?.statusMessage, { toastId: 2 });
          setRecord(false);
          return;
        }
        toast.error(data.data.statusMessage);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.statusMessage);
      })
      .finally(() => setLoading(false));
  };
  return (
    <Modal open={record} onClose={() => setRecord(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 800,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 10,
        }}
      >
        <div className="flex justify-between text-xl font-bold text-black">
          <p className="text-3xl">Prepayment</p>{" "}
          <p
            className="cursor-pointer text-3xl"
            onClick={() => setRecord(false)}
          >
            X
          </p>
        </div>

        <form onSubmit={(e) => handleSubmit(e)} className="my-5 space-y-4">
          <div className="w-full">
            <label className="text-baseFont font-bold mb-2">Start Date</label>

            <input
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              id="class-name"
              max={endDate}
              required
              name="startDate"
              type="date"
              className="form__input"
              placeholder="Enter Comment please"
            />
          </div>

          <div className="w-full">
            <label className="text-baseFont font-bold mb-2">End Date</label>

            <input
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              id="class-name"
              min={startDate}
              required
              name="endDate"
              type="date"
              className="form__input"
              placeholder="Enter Comment please"
            />
          </div>

          <div className="w-full">
            <label className="text-baseFont font-bold mb-2">
              Month Duration
            </label>

            <input
              name="monthDuration"
              id="class-name"
              value={monthDuration}
              readOnly
              required
              type="number"
              className="form__input"
            />
          </div>

          <div className="w-full">
            <label className="text-baseFont font-bold mb-2">Amount</label>

            <input
              readOnly
              value={amount?.toLocaleString()}
              id="class-name"
              required
              name="amount"
              className="form__input"
              placeholder="Enter Amount"
            />
          </div>

          <button
            disabled={loading}
            type="submit"
            className=" bg-[#305F32] text-[#EFF6F0] hover:bg-[#2b562d] py-2 px-4 font-semibold rounded block mx-auto items-center gap-2 text-sm h-10 outline outline-1 outline-[#305F32]"
          >
            {loading ? "Submitting" : "Submit"}
          </button>
        </form>
      </Box>
    </Modal>
  );
};

export default SetupPrepayment;
